import { $ } from '../utils/Utils';

const header = (() => {
  const config = {
    trigger: document.querySelector('.js-header'),
    compactCN: '-compact',
    showCN: '-show',
    toHideFromReader: [...$('.js-headerHide')],
    nextElement: document.querySelector('.js-headerNextElement'),
    scrolled: false,
    transitionTolken: false,
  };

  let h = config.trigger.offsetHeight;
  let limit = h * 2;

  const adjustHeaderSpacing = () => {
    const paddingTop = parseFloat(config.nextElement.style.paddingTop);
    // update only if necessary
    if (h !== paddingTop) {
      config.nextElement.style.paddingTop = `${h}px`;
    }
  };

  const updateLimit = () => {
    h = config.trigger.offsetHeight;
    limit = h * 2;

    adjustHeaderSpacing();
  };

  const handleHeaderSpacing = () => {
    // perform updateLimit() only when the header has finished with all its transitions
    // so we had some checks with setTimeout
    if (config.transitionTolken) {
      clearTimeout(config.transitionTolken);
    }

    config.transitionTolken = setTimeout(() => {
      updateLimit();
      config.transitionTolken = false;
    }, 200);
  };

  const updateHeader = () => {
    // get Y position of the page (scrollY doesn't work on IE)
    const Y = window.scrollY || pageYOffset;

    if (Y > limit) {
      // to avoid calling the same actions too many times
      // let's put a scrolled tolken
      if (!config.scrolled) {
        // update scrolled tolken
        config.scrolled = true;
        // add compact classname
        config.trigger.classList.add(config.compactCN);
        config.trigger.classList.remove(config.showCN);
        // if classname is present, add aria attribute for accessibility
        // this will prevent from focusing on the navs that we hid
        if (config.toHideFromReader.length > 0) {
          config.toHideFromReader.forEach(element =>
            element.setAttribute('aria-hidden', 'true'));
        }

        // remove listener on transition end
        config.trigger.removeEventListener(
          'transitionend',
          handleHeaderSpacing,
        );
      }
    } else {
      // to avoid calling the same actions too many times
      // let's put a scrolled tolken
      if (config.scrolled) {
        // update scrolled tolken
        config.scrolled = false;
        // remove+ compact classname
        config.trigger.classList.remove(config.compactCN);
        config.trigger.classList.add(config.showCN);
        // if classname is present, remove aria attribute for accessibility
        // this will allow focus on the previously hidden navs
        if (config.toHideFromReader.length > 0) {
          config.toHideFromReader.forEach(element =>
            element.removeAttribute('aria-hidden'));
        }

        // let's calculate the size of the header when the it has its initial height
        config.trigger.addEventListener('transitionend', handleHeaderSpacing);
      }
    }
  };

  const build = () => {
    // adjust the padding-top of the <main>
    adjustHeaderSpacing();
    // handler events
    window.addEventListener('scroll', updateHeader);
    window.addEventListener('resize', updateLimit);
  };

  const init = () => {
    if (config.trigger) {
      build();
    }
  };

  return {
    init,
  };
})();

export default header.init();
